export const projects = [
  {
    title: "Momento",
    subtitle: "Advanced Discord Bot",
    description:
      "Momento is an open source, fully functional Discord bot that includes moderation, reaction roles, music features, and so much more.",
    image: "./Momento.png",
    link: "https://github.com/momentodevs/momento",
  }
];

export const testimonials = [
  {
    quote:
      "We're in the business of supporting people all over the world who want to build digital socially relevant products. We are totally open, we don't need anything from anyone.",
    image: "https://unicornwitnesses.com/img/aleksei_dolgikh_photo.jpg",
    name: "Aleksei Dolgikh",
    company: "UnicornWitnesses.com",
  },
];

export const skills = [
  "JavaScript",
  "Python",
  "Discord.js Bots",
  "React",
  "Next.js",
  "Node",
  "GraphQL", 
  "Material UI",
];



// WEBPACK FOOTER //
// ./src/data.js